//#region  Firebase config
// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// import firebase from "firebase";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAuth, signInWithEmailAndPassword } from "firebase/auth";



// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
export const firebaseConfig = {
  apiKey: "AIzaSyDDqaemPc5oNtpQ-4UJhJY_pXD9Qa2Xifw",
  authDomain: "hidiarch-studio-project.firebaseapp.com",
  projectId: "hidiarch-studio-project",
  storageBucket: "hidiarch-studio-project.appspot.com",
  messagingSenderId: "877668814460",
  appId: "1:877668814460:web:b1a1e0a13cef8f221f83f9",
  measurementId: "G-C98G5086Q0"
};

// Initialize Firebase
const firebaseApp = initializeApp(firebaseConfig);
// const analytics = getAnalytics(firebaseApp);
const db = getFirestore(firebaseApp);

const auth = getAuth();
signInWithEmailAndPassword(auth, 'tructran25.98@gmail.com', 'hidiarchstudio')

export const storage = getStorage(firebaseApp);

export default db;